<template src="./wheelhouseIntegrationDetail.template.html"></template>
<script>
    import moment from "moment-timezone";
    import * as axios from "axios";
    import VeeValidate from "vee-validate";
    import Vue from "vue";
    import foliomodal from "../../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue"
    Vue.use(VeeValidate);
    export default {
        components: {
            foliomodal
        },
        name: "wheelhouseIntegrationDetail",
        props: [],
        data() {
            return {
                wheelHouseIntegratedUsersList: [],
                ratePlanList: [],
                SelectedwheelHouseUser: {},
                clientDetails: {}
            }
        },

        methods: {
            changeInDerivedRateplan() {
                let vm = this;
                if (vm.SelectedwheelHouseUser.RatePlanId == vm.SelectedwheelHouseUser.derivedRateplanId) {
                    vm.SelectedwheelHouseUser.derivedRateplanId = null
                }
                if (vm.SelectedwheelHouseUser.derivedRateplanId == null || vm.SelectedwheelHouseUser.derivedRateplanId == 'null') {
                    vm.SelectedwheelHouseUser.Amount = 0
                }
            },
            GetRateplanList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_RatePlanList",
                    params: {
                        ModuleAction: "Get_RatePlanList",
                        StatusId: 1,
                        SearchText: null,
                        Tagtext: null
                    },
                    callback: function (err, response) {

                        if (err) {
                            return
                        }
                        if (response) {
                            console.log("GetRateplanList", response)
                            vm.ratePlanList = response[1]

                        }
                    }
                })
            },
            SaveIntegrations() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "SaveIntegrations",
                    params: {
                        ModuleAction: "SaveIntegrations",
                        crsId: null,
                        // ClientCode: vm.SelectedwheelHouseUser.Integrators_UserId,
                        username: vm.SelectedwheelHouseUser.UserName,
                        password: vm.SelectedwheelHouseUser.Password,
                        statusId: vm.SelectedwheelHouseUser.StatusId,
                        isDefault: vm.SelectedwheelHouseUser.IsDefault,
                        // UnitId: vm.unitId,
                        // PropertyId: vm.propertyId,
                        UsersPassword: vm.SelectedwheelHouseUser.Password,
                        User_ApiKey: vm.SelectedwheelHouseUser.User_ApiKey,
                        RatePlanId: vm.SelectedwheelHouseUser.RatePlanId,
                        IntegrationId: 5,
                        EmailId: vm.SelectedwheelHouseUser.EmailId,
                        Integrators_UserId: vm.SelectedwheelHouseUser.Integrators_UserId,
                        PhoneNumber: vm.SelectedwheelHouseUser.PhoneNumber,
                        derivedRateplanId: vm.SelectedwheelHouseUser.derivedRateplanId,
                        Amount: vm.SelectedwheelHouseUser.Amount,
                        isPercentage: vm.SelectedwheelHouseUser.isPercentage,
                        isPositive: vm.SelectedwheelHouseUser.isPositive,
                        CalculateDerivedRates: vm.SelectedwheelHouseUser.CalculatedDerivedRates
                    },
                    callback: function (err, response) {

                        if (err) {
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error!",
                                message: "Error in creating user"
                            });
                            return
                        }
                        if (response) {
                            console.log("user inactive = ", response)
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Updated Successfully"
                            });
                            vm.GetWheelHouseUserList();
                            if (vm.SelectedwheelHouseUser.CalculatedDerivedRates == 1) {
                                vm.CalculateDerivedRatesForWheelhouse()
                            }
                        }


                    }
                })
                // vm.isModalVisible = false

            },
            CalculateDerivedRatesForWheelhouse() {
                let vm = this
                let DerivedOffsetAmount = 0

                const sign = vm.SelectedwheelHouseUser.isPositive ? "+" : "-";
                const amount = vm.SelectedwheelHouseUser.Amount || 0;
                DerivedOffsetAmount = amount ? sign + amount : amount;

                vm.$store.dispatch("dataRequestHandler", {
                    key: "CalculateDerivedRates_Integration",
                    params: {
                        ModuleAction: "CalculateDerivedRates_Integration",
                        derivedRateplanId: vm.SelectedwheelHouseUser.derivedRateplanId,
                        isPercentage: vm.SelectedwheelHouseUser.isPercentage,
                        Amount: DerivedOffsetAmount,
                        RatePlanId: vm.SelectedwheelHouseUser.RatePlanId,
                        integrationId: 5
                    },
                    callback: function (err, response) {

                    }
                })
            },
            GetWheelHouseUserList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_ListOfIntegrations_RU",
                    params: {
                        ModuleAction: "Get_ListOfIntegrations_RU",
                        PropertyId: null,
                        UnitId: null
                    },
                    callback: function (err, response) {
                        if (response[0].length) {
                            vm.wheelHouseIntegratedUsersList = response[0]
                            vm.SelectedwheelHouseUser = vm.wheelHouseIntegratedUsersList.filter(element => {
                                if (element.IntegrationId == 5)
                                    return element

                            })[0];
                        }
                        console.log("vm.SelectedwheelHouseUser", vm.SelectedwheelHouseUser)
                        // vm.GetRateplanList()
                        // vm.$emit('wheelHouseUserList', vm.wheelHouseIntegratedUsersList);
                    }
                })
                setTimeout(() => {
                    vm.openWheelHouseComponent = false;
                }, 1000);
            },
            GetClientDetailById() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetClientDetailById",
                    params: {
                        ModuleAction: "GetClientDetailById"
                    },
                    callback: function (err, response) {
                        if (response.recordsets[5].length) {
                            vm.clientDetails = response.recordsets[5][0]
                            vm.clientDetails.Email = response.recordsets[6][0].Email;
                            vm.clientDetails.PhoneNumber = response.recordsets[6][0].PhoneNumber
                        }
                        // vm.GetWheelHouseUserList();
                    }
                })

            },

        },
        watch: {

        },
        computed: {},

        mounted() {
            let vm = this;
            vm.GetWheelHouseUserList();
            vm.GetRateplanList();
            vm.GetClientDetailById();
        }
    };
</script>